import React from 'react';
import { mockIncomeExpense, formatCurrency } from '../../../services/mockData';

const IncomeExpenditure = () => {
  const totalExpCurrent = mockIncomeExpense.expenditures.reduce((s, e) => s + e.current, 0);
  const totalExpPrev = mockIncomeExpense.expenditures.reduce((s, e) => s + e.prev, 0);
  const totalIncCurrent = mockIncomeExpense.incomes.reduce((s, e) => s + e.current, 0);
  const totalIncPrev = mockIncomeExpense.incomes.reduce((s, e) => s + e.prev, 0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Final Accounts <span>/ Income &amp; Expenditure</span></div>
        <h2>Income &amp; Expenditure</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>From</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group">
          <label>To</label>
          <input type="date" className="form-control" />
        </div>
        <div className="form-group">
          <label>Options</label>
          <label style={{ display: 'flex', gap: '4px', alignItems: 'center', paddingTop: '6px', fontWeight: '600', fontSize: '13px', cursor: 'pointer' }}>
            <input type="checkbox" /> Include Prefix to Ledgers
          </label>
        </div>
        <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-primary">🔍 Search</button>
            <button className="btn btn-warning btn-sm">🖨️ Print</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header" style={{ marginBottom: '16px' }}>
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            Income and Expenditure Report for the Period: 01-04-2025 to 31-03-2026
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* EXPENDITURES */}
          <div>
            <div className="section-title" style={{ marginBottom: '10px' }}>EXPENDITURES</div>
            <table>
              <thead>
                <tr>
                  <th>Head</th>
                  <th className="amount">2025-2026</th>
                  <th className="amount">2024-2025</th>
                </tr>
              </thead>
              <tbody>
                {mockIncomeExpense.expenditures.map((e, i) => (
                  <tr key={i}>
                    <td style={{ fontSize: '12px' }}>{e.head}</td>
                    <td className="amount">{e.current > 0 ? formatCurrency(e.current) : ''}</td>
                    <td className="amount" style={{ color: '#718096' }}>{e.prev > 0 ? formatCurrency(e.prev) : ''}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td><b>Total Expenditure</b></td>
                  <td className="amount dr"><b>{formatCurrency(totalExpCurrent)}</b></td>
                  <td className="amount" style={{ color: '#718096' }}>{formatCurrency(totalExpPrev)}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* INCOMES */}
          <div>
            <div className="section-title" style={{ marginBottom: '10px' }}>INCOMES</div>
            <table>
              <thead>
                <tr>
                  <th>Head</th>
                  <th className="amount">2025-2026</th>
                  <th className="amount">2024-2025</th>
                </tr>
              </thead>
              <tbody>
                {mockIncomeExpense.incomes.map((e, i) => (
                  <tr key={i}>
                    <td style={{ fontSize: '12px' }}>{e.head}</td>
                    <td className="amount">{e.current > 0 ? formatCurrency(e.current) : ''}</td>
                    <td className="amount" style={{ color: '#718096' }}>{e.prev > 0 ? formatCurrency(e.prev) : ''}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td><b>Total Income</b></td>
                  <td className="amount cr"><b>{formatCurrency(totalIncCurrent)}</b></td>
                  <td className="amount" style={{ color: '#718096' }}>{formatCurrency(totalIncPrev)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeExpenditure;
